import { CreateMediaCommerceDto, 
  MediaCommerceDto, 
  UpdateMediaCommerceDto } from '@sr/dto';
import { mediaApi } from 'entities/media/api-slice';
import { MEDIA_BASE_URL } from 'shared/api/api';

const injectedApi = mediaApi.injectEndpoints({
  endpoints: (builder) => ({
    getMediaCommerce: builder.query<MediaCommerceDto[], number>({
      query: (id: number) => ({
        url: `${MEDIA_BASE_URL}/${id}/commerce`,
        method: 'GET'
      }),
      providesTags: (result, error, id) =>
        result
          ? [
            ...result.map(({ id }) => ({ type: 'media-commerce' as const, id })),
            { type: 'media-commerce' as const, id: 'LIST' }
          ]
          : [{ type: 'media-commerce' as const, id: 'LIST' }]
    }),

    addMediaCommerce: builder.mutation<MediaCommerceDto, CreateMediaCommerceDto>({
      query: (data) => ({
        url: `${MEDIA_BASE_URL}/commerce`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: [{ type: 'media-commerce', id: 'LIST' }]
    }),

    updateMediaCommerce: builder.mutation<UpdateMediaCommerceDto, Partial<MediaCommerceDto>>({
      query: ({ id, ...data }) => ({
        url: `${MEDIA_BASE_URL}/commerce/${id}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'media-commerce', id },
        { type: 'media-commerce', id: 'LIST' }
      ]
    }),
    
    deleteMediaCommerce: builder.mutation<void, number>({
      query: (id) => ({
        url: `${MEDIA_BASE_URL}/commerce/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'media-commerce', id },
        { type: 'media-commerce', id: 'LIST' }
      ]
    })
  })
});

export const mediaCommerceApi = injectedApi;

export const {
  useGetMediaCommerceQuery,
  useAddMediaCommerceMutation,
  useUpdateMediaCommerceMutation,
  useDeleteMediaCommerceMutation
} = mediaCommerceApi;
